import { css } from '@/styled-system/css';

export const alert = css({
  width: 'full',
  backgroundColor: { base: 'aqua.50', lg: 'teal.50' },
  borderColor: 'aqua.100',
  _dark: {
    backgroundColor: 'bg.softest',
    borderColor: 'border.muted',
  },
  '& > svg:first-child': {
    display: 'none',
  },
});

export const body = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: 'tighter',
  minWidth: 0,
  color: { base: 'aqua.800', _dark: 'text.neutral' },
});

export const titleRow = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'tighter',
});

export const offerIconContainer = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '750',
  height: '750',
  borderRadius: '200',
  backgroundColor: { base: 'aqua.600', _dark: 'bg.express.trust.hero' },
  flexShrink: 0,
});

export const offerIcon = css({
  color: { base: 'white', _dark: 'icon.onHero.neutral' },
});

export const title = css({
  color: { base: 'aqua.950', _dark: 'text.neutral' },
  fontWeight: 'bold',
});

export const description = css({
  color: { base: 'aqua.800', _dark: 'text.neutral' },
  margin: 0,
  overflow: 'hidden',
});

export const collapsedDescription = css({
  lineClamp: 2,
});

export const additionalOffers = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'tightest',
  margin: 0,
  padding: 0,
  listStyle: 'none',
});
